import React, { useEffect, useState } from "react";
import OPPCss from "../../Dashboard/Opportunities/Opportunities.module.scss";
import Sidebar from "../Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader/Loader";
import LocationDropdown from "../../Dashboard/VenueListComp/LocationDropdown";
import "../../Dashboard/VenueListComp/VenueList.scss";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FacilityIdDropdown from "../../Dashboard/VenueListComp/FacilityIdDropdown";

function AllBookingAdmin() {
  const navigate = useNavigate();

  const [hideSvg, setHideSvg] = useState(false);
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [noData, setNoData] = useState(false);
  const [location, setLocation] = useState("All"); // Default to All
  const [startDate, setStartDate] = useState(null); // Use null for DatePicker
  const [endDate, setEndDate] = useState(null); // Use null for DatePicker
  const [facilityId, setFacilityId] = useState("All"); // Default to All
  const [facilities, setFacilities] = useState([]); // Store facility list

  const handleSvg = () => {
    setHideSvg(!hideSvg);
  };

  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Define the seven-day range for DatePicker
  const today = new Date();
  const maxDate = new Date();
  maxDate.setDate(today.getDate() + 7); // Seven days from today

  const fetchFacilities = async () => {
    const token = localStorage.getItem("access_token");
    const url = `https://ballersapi.ballerslife.co/api/v1/admin/membership/get_all_facility`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch facilities");
      }
      const data = await response.json();
      setFacilities(data || []);
    } catch (err) {
      console.error("Error fetching facilities:", err);
      setFacilities([]);
    }
  };

  const fetchBookings = async () => {
    setLoading(true);
    const token = localStorage.getItem("access_token");
    let url = `https://ballersapi.ballerslife.co/api/v1/admin/all_bookings`;

    // Build query parameters only if filters are applied
    const queryParams = [];
    if (location !== "All") {
      queryParams.push(`status=${location.toLowerCase()}`);
    }
    if (startDate) {
      const formattedStartDate = formatDate(startDate);
      queryParams.push(`start_date=${formattedStartDate}`);
    }
    if (endDate) {
      const formattedEndDate = formatDate(endDate);
      queryParams.push(`end_date=${formattedEndDate}`);
    }
    if (facilityId !== "All") {
      queryParams.push(`facility_id=${facilityId}`);
    }

    // Append query parameters if any exist
    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      setBookings(data.bookings || []);
      setNoData(data.bookings.length === 0);
      setLoading(false);
    } catch (err) {
      setNoData(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFacilities();
  }, []); // Fetch facilities on mount

  useEffect(() => {
    fetchBookings();
  }, [location, startDate, endDate, facilityId]); // Re-fetch when filters change

  useEffect(() => {
    document.title = `All Bookings | Ballers`;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const handleBookingClick = (booking) => {
    navigate("/admin/allbookings/details", {
      state: { member: booking.booking_id },
    });
  };

  // Format facility options for dropdown
  const facilityOptions = [
    { id: "All", label: "All" },
    ...facilities.map((facility) => ({
      id: facility.facility_id,
      label: `${facility.facility_id} - ${facility.facility_name}`,
    })),
  ];

  return (
    <div className="dashMain">
      <div className="sideBar">
        <Sidebar />
      </div>
      {hideSvg ? (
        <div className="sideBarMobile">
          <Sidebar />
        </div>
      ) : (
        <div></div>
      )}
      <div className="content">
        <div className="filtersAllBooking">
          <div className="dropdownAllBooking">
            <label htmlFor="location-select">Status:</label>
            <LocationDropdown
              location={location}
              setLocation={setLocation}
              locationOptions={[
                "All",
                "Confirmed",
                "Completed",
                "Pending",
                "Cancelled",
              ]}
            />
          </div>
          <div className="dropdownAllBooking">
            <label htmlFor="facility-select">Facility:</label>
            <FacilityIdDropdown
              location={facilityId}
              setLocation={setFacilityId}
              locationOptions={facilityOptions}
            />
          </div>
          <div className="dropdownAllBookingMemberList">
            {/* <label htmlFor="start-date">Start Date:</label> */}
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              dateFormat="yyyy-MM-dd"
              placeholderText="Select start date"
              className="datePickerMemberList"
            />
          </div>
          <div className="dropdownAllBookingMemberList">
            {/* <label htmlFor="end-date">End Date:</label> */}
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              dateFormat="yyyy-MM-dd"
              placeholderText="Select end date"
              className="datePickerMemberList"
            />
          </div>
        </div>
        {loading ? (
          <Loader />
        ) : noData ? (
          <div className={OPPCss.fcAllBookingMain}>No bookings available.</div>
        ) : (
          <>
            <div className={OPPCss.fcAllBookingMain}>
              <div className={OPPCss.fcAllBookingHeader}>
                <div className={OPPCss.fcAllBookingCell}>
                  <p className="investmentHeader">USER</p>
                </div>
                <div className={OPPCss.fcAllBookingCell}>
                  <p className="investmentHeader">FACILITY NAME</p>
                </div>
                <div className={OPPCss.fcAllBookingCell}>
                  <p className="investmentHeader">DATE</p>
                </div>
                <div className={OPPCss.fcAllBookingCell}>
                  <p className="investmentHeader">TIME</p>
                </div>
                <div className={OPPCss.fcAllBookingCell}>
                  <p className="investmentHeader">DURATION (HRS)</p>
                </div>
                <div className={OPPCss.fcAllBookingCell}>
                  <p className="investmentHeader">COURTS</p>
                </div>
                <div className={OPPCss.fcAllBookingCell}>
                  <p className="investmentHeader">STATUS</p>
                </div>
              </div>
              {bookings.map((booking, index) => (
                <div
                  className={OPPCss.fcAllBookingRow}
                  key={booking.id}
                  onClick={() => handleBookingClick(booking)}
                >
                  <div className={OPPCss.fcAllBookingCell}>
                    <p>{booking.user}</p>
                  </div>
                  <div className={OPPCss.fcAllBookingCell}>
                    <p>{booking.facility_name}</p>
                  </div>
                  <div className={OPPCss.fcAllBookingCell}>
                    <p>{booking.date}</p>
                  </div>
                  <div className={OPPCss.fcAllBookingCell}>
                    <p>{booking.time}</p>
                  </div>
                  <div className={OPPCss.fcAllBookingCell}>
                    <p>{booking.duration_hrs}</p>
                  </div>
                  <div className={OPPCss.fcAllBookingCell}>
                    <p>{booking.courts_req}</p>
                  </div>
                  <div className={OPPCss.fcAllBookingCell}>
                    <p>{booking.status}</p>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default AllBookingAdmin;
